export var isModifierKeyPressed = function (e) {
    if (!e) {
        return false;
    }
    var event = 'nativeEvent' in e ? e.nativeEvent : e;
    return !!(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
};
